<template>
  <div class="row p-0 m-0 welcome-row">
    <div class="col-12 col-md-6 p-0 welcome-col">
      <p style="font-size: 48px">Welcome!</p>
      <p style="font-size: 18px" class="mb-4">
        Weekly blog articles with all things programming including HTML, CSS,
        JavaScript and more. Register today to never miss a post! Lorem ipsum
        dolor sit amet consectetur adipisicing elit. Eum corrupti, dolorum
        repudiandae recusandae doloribus.
      </p>
      <router-link
        v-if="!this.$store.state.isLoggedIn"
        to="/login"
        style="font-size: 14px"
        >Login/Register -></router-link
      >
    </div>
    <div class="col-12 col-md-6 p-0">
      <img src="../assets/welcome.jpg" class="welcome-img img-fluid" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Welcome",
  components: {},
  data() {
    return {};
  },
};
</script>

<style scoped>
.welcome-col {
  color: white;
  padding: 20px 100px 20px 100px !important;
}
@media (max-width: 450px) {
  .welcome-col {
    order: 2;
    padding: 20px 50px 20px 50px !important;
  }
}
.welcome-row {
  background-color: #303030;
  align-items: center;
}
</style>
